/**
 * Storage Service
 * 
 * This service handles browser storage operations for the application,
 * particularly for provisional booking information.
 */

// Constants for storage keys
const PROVISIONAL_BOOKING_KEY = 'provisionalBookingNumber'

/**
 * Stores the provisional booking number in session storage
 * @param bookingNumber The booking number to store
 * @param isProvisional Optional flag to verify this is a provisional booking
 */
export const storeProvisionalBookingInfo = (
  bookingNumber: string,
  isProvisional?: boolean
): void => {
  if (!bookingNumber) {
    console.warn('Attempted to store empty booking number')
    return
  }
  
  // If isProvisional flag is provided and false, don't store
  if (isProvisional === false) {
    console.warn('Attempted to store non-provisional booking as provisional')
    return
  }
  
  try {
    sessionStorage.setItem(PROVISIONAL_BOOKING_KEY, bookingNumber)
  } catch (error) {
    console.error('Failed to store provisional booking info:', error)
  }
}

/**
 * Retrieves the stored provisional booking number from session storage
 * @returns The stored booking number or null if not found
 */
export const getStoredProvisionalBookingNumber = (): string | null => {
  try {
    return sessionStorage.getItem(PROVISIONAL_BOOKING_KEY)
  } catch (error) {
    console.error('Failed to retrieve provisional booking info:', error)
    return null
  }
}

/**
 * Clears the provisional booking information from session storage
 */
export const clearProvisionalBookingInfo = (): void => {
  try {
    sessionStorage.removeItem(PROVISIONAL_BOOKING_KEY)
  } catch (error) {
    console.error('Failed to clear provisional booking info:', error)
  }
}
